import * as React from "react";

interface RenderOptions {
    id: string;
    when: any;
    withClasses?: string;
    children: any;
    style?: object;
    tooltip?: string;
    isTooltipHtml?: boolean;
}

function Render({
    id,
    when,
    withClasses,
    children,
    style,
    tooltip,
    isTooltipHtml,
}: RenderOptions) {
    if (!withClasses) {
        withClasses = "";
    }

    const toRender = when ? (
        <span
            id={`Render_${id}`}
            className={withClasses}
            style={style}
            data-tip={tooltip}
            data-html={isTooltipHtml === undefined ? false : isTooltipHtml}
        >
            {children}
        </span>
    ) : null;

    return toRender;
}

export default Render;

export function RenderDiv({
    id,
    when,
    withClasses,
    children,
    tooltip,
    isTooltipHtml,
}: RenderOptions) {
    if (!withClasses) {
        withClasses = "";
    }

    return when ? (
        <div
            id={`Render_${id}`}
            className={withClasses}
            data-tip={tooltip}
            data-html={isTooltipHtml === undefined ? false : isTooltipHtml}
        >
            {children}
        </div>
    ) : null;
}
